import { render, staticRenderFns } from "./TheaterOrganizationSidebar.vue?vue&type=template&id=1dc94b43&scoped=true"
import script from "./TheaterOrganizationSidebar.vue?vue&type=script&lang=js"
export * from "./TheaterOrganizationSidebar.vue?vue&type=script&lang=js"
import style0 from "./TheaterOrganizationSidebar.vue?vue&type=style&index=0&id=1dc94b43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc94b43",
  null
  
)

export default component.exports